// Component to render custom launcher
import { useEffect, useState } from 'react';
import userflow from 'userflow.js';
import './UserflowResourceCenterLauncher.scss';

/**
 * This functional component represents a launcher button for the Userflow Resource Center.
 * The component displays the number of uncompleted tasks in the resource center.
 *
 * @returns {React.ReactElement} The rendered React element representing the Userflow Resource Center launcher.
 *
 * @example
 * // Usage example:
 * <UserflowResourceCenterLauncher />
 */
const UserflowResourceCenterLauncher = (): React.ReactElement => {
  // Monitor resource center state so we can display number of uncompleted tasks
  const [resourceCenterState, setResourceCenterState] = useState(() => userflow.getResourceCenterState());
  useEffect(() => {
    const onChange = () => {
      setResourceCenterState(userflow.getResourceCenterState());
    };
    userflow.on('resourceCenterChanged', onChange);
    return () => userflow.off('resourceCenterChanged', onChange);
  }, []);

  return (
    <div className="userflow-resource-center-launcher">
      <button className="button" onClick={() => userflow.openResourceCenter()}>
        Guided Tours
        {resourceCenterState &&
          resourceCenterState.uncompletedChecklistTaskCount > 0 &&
          ` (${resourceCenterState.uncompletedChecklistTaskCount})`}
      </button>
    </div>
  );
};

export default UserflowResourceCenterLauncher;
